if (!customElements.get('popup-dialog')) {
  customElements.define(
    'popup-dialog',
    class PopupDialog extends ModalDialog {
      connectedCallback() {
        super.connectedCallback();
        if (sessionStorage.getItem('popup-dismissed') === '1') return;
        setTimeout(() => this.show(), 600);
      }

      hide() {
        super.hide();
        sessionStorage.setItem('popup-dismissed', '1');
      }
    }
  );
}
